<template>
  <unauth-base-card :tip="tip">
    <template v-slot:top>
      <back-button v-show="!sent" />
    </template>

    <v-card-text v-if="!sent">
      <v-form v-on:submit.prevent="sendRequest" ref="form">
        <v-text-field
          label="Email"
          type="email"
          name="email"
          v-model="email"
          required
          :rules="validEmail"
        ></v-text-field>
      </v-form>
      <v-row class="my-5">
        <v-col class="text-center pb-0">
          <v-btn
            large
            class="elevation-0 unauth-action-btn unauth-submit-btn"
            @click="sendRequest"
          >
            <span>Send Request</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text v-else>
      <v-row class="my-5">
        <v-col class="text-center pb-0">
          <v-btn
            large
            class="elevation-0 unauth-action-btn unauth-submit-btn"
            :to="{ name: 'LoginView' }"
          >
            <span>Done</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </unauth-base-card>
</template>

<script>
import rules from '@anchor/vue-assets/src/plugins/form-rules';

import BackButton from '@/components/unauth/BackButton';
import UnauthBaseCard from '@/components/unauth/UnauthBaseCard';


export default {
  name: 'ForgotPasswordCard',
  components: {
    BackButton,
    UnauthBaseCard,
  },
  data: () => ({
    sent: false,
    email: '',
    validEmail: [rules.required, rules.email],
  }),
  computed: {
    tip() {
      return this.sent ?
        `
          We've sent you an email with instructions to reset your password.
          Please make sure it didn't wind up in your Junk Mail.
        ` :
        'Enter your email and we will send you a link to reset your password';
    },
  },
  methods: {
    sendRequest() {
      if (this.$refs.form.validate()) {
        this.$requests.post(`auth/sendResetLink?email=${this.email}`)
          .then(res => {
            if (res.data.success) {
              this.sent = true;
            } else {
              this.$toast.error('Service unavailable, please try again later!', { timeout: 3000 });
            }
          })
          .catch(err => {
            this.$toast.error(err.response.data, { timeout: 3000 });
          });
      }
    },
  },
};
</script>
